<template>
  <div>
    <div class="header" style="display:flex;justify-content: center;">
      <img style="width:30px;height:30px;margin-top:4px;margin-right: 8px;"  src="@/assets/doors.png" alt=""/>
       <p class="title">地磅称重管理系统</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "xboot-header",
  computed: {
    // 主题
    mainTheme() {
      return this.$store.state.theme.theme.mainTheme;
    },
  },
};
</script>

<style lang="less" scoped>
.title {
    font-size: 26px;
    color: gray;
    font-weight: bolder;
}
.header {
  margin-top: 8vh;
  margin-bottom: 5vh;
  text-align: center;

  .description {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.45);
    margin-top: 1vh;
  }
}
</style>
